import React from "react";

export const CalcResult = ({ score, unchosenField, labels, display }) => {
  return(
    <div className={`result-row ${display}`} aria-labelledby="resultLabel resultScore" tabIndex="0">
      <span id="resultLabel" className="result-label">{labels[`${unchosenField}Found`]} </span>
      <span id="resultScore" className="result-score">{score}</span>
    </div>
  )
}